<template>
  <div class="statistics-chart">
    <div v-if="!tableEditOpen" class="chart-panel" :class="(isMobile && mobileChartTypeOpen) ? 'menu-grow' : 'menu-hidden'">
      <div
        v-for="chart in availableCharts"
        :key="chart.id"
        class="chart-item"
        :class="{'active': currentChart===chart, 'disabled': !chart.enableable, 'enableable': chart.enableable && !chart.enabled}"
        @click="currentChart = chart"
      >
        <div class="chart-icon" :class="chart.id" />
        <div class="chart-text">{{ chart.label }}</div>        
        <div v-if="chart.enableable && !chart.enabled" class="enable-button">
          <div class="enable-icon" />
          Crear
        </div>
      </div>
    </div>
    <PivotComponent
      v-model="internalPivotConfig"
      :data="contentData.data"
      :dimensions="contentData.dimensions"
      :data-card="dataCard" 
      mode="edit"
      component="chart"
      :current-chart="currentChart"
      :default-pivot-config="defaultPivotConfig"
      :table-edit-open="tableEditOpen"
      @toggle-edit="toggleTableEdit"
      @reload-data-card="reloadDataCard"
    />
  </div>
</template>

<script>
import PivotComponent from '../table/PivotComponent.vue'
// import { getStatisticsTable } from '@/services/table-api'
import { pickDefaultChart, getChartsAvailability } from '@/utils/dimensionUtils.js'
import { t } from '../../i18n/index'

// import SVDChart from './SVDChart.vue'
export default {
  components: { PivotComponent },
  model: {
    prop: 'pivotConfig',
    event: 'change',
  },
  props: ['dataCard', 'pivotConfig', 'mobileChartTypeOpen', 'contentData'],

  data() {
    return {
      defaultPivotConfig: null, //pivotConfigFile
      tableEditOpen: false,
    }
  },
  computed: {
    currentChartId: {
      get() {
        return this.$route.query.chart || null
      },
      set(v) {
        let q = { ...this.$route.query, chart: v }
        delete q.diff
        delete q.ccfg
        if (this.dataCard.data[0].favourites.length > 0) {
          let favs = this.dataCard.data[0].favourites
          let fav
          if (favs.length > 0)
            fav = favs.find(el => el.payload && el.payload.indexOf(v) !== -1)
          if (fav) {
            let langSource = null
            if (this.$store.state.i18n.lang === 'ca') langSource = 'estad%C3%ADstiques'
            else if (this.$store.state.i18n.lang === 'es') langSource = 'estad%C3%ADsticas'
            else if (this.$store.state.i18n.lang === 'en') langSource = 'statistics'
            this.$router.push('/' + this.$store.state.i18n.lang + '/' + langSource + '/' + this.dataCard.data[0].id + '?' + fav.payload)
          }
          else this.$router.replace({ query: q })
        }
        else this.$router.replace({ query: q })
      },
    },
    currentChart: {
      get() {
        return this.currentChartId && this.availableCharts.find(c => c.id === this.currentChartId)
      },
      set(v) {
        this.currentChartId = v.id
      },
    },
    charts() {
      return [
        {
          id: 'line-chart',
          label: t('line_chart'),
        },
        {
          id: 'bar-chart',
          label: t('bar_chart'),
        },
        {
          id: 'stacked-chart',
          label: t('stacked_bar_chart'),
        },
        {
          id: 'grouped-chart',
          label: t('grouped_bar_chart'),
        },
        {
          id: 'pie-chart',
          label: t('pie_chart'),
        },
        {
          id: 'heat-map',
          label: t('heatmap'),
        },
        {
          id: 'connected-dotplot',
          label: t('connected_dotplot'),
        },
        {
          id: 'radar-chart',
          label: t('radar_chart'),
        },
        {
          id: 'tree-map',
          label: t('treemap'),
        },
        {
          id: 'pyramid-chart',
          label: t('pyramid_chart'),
        },
      ]
    },
    availableCharts() {
      if (!this.contentData) return []
      let statuses = getChartsAvailability(this.contentData.dimensions, this.charts, this.dataCard)
      return this.charts.map(c => {
        return {
          ...c,
          ...statuses.find(s => s.id === c.id),
        }
      })
    },
    internalPivotConfig: {
      get() {
        return this.pivotConfig
      },
      set(value) {
        this.$emit('change', value)
      },
    },
  },
  // asyncComputed: {
  //   contentData() {
  //     return this.dataCard.dims && getStatisticsTable(this.dataCard)
  //   },
  // },
  watch: {
    contentData: {
      handler(value) {
        if (!value) return

        if (!this.currentChart) {
          // this.$emit(
          //   'change-current-chart',
          //   pickDefaultChart(this.contentData.dimensions, this.availableCharts)
          // )
          this.currentChart = pickDefaultChart(this.contentData.dimensions, this.availableCharts)
        } else {
          // this.setDefaultConfigs()
        }
      },
      immediate: true,
    },
    currentChartId: {
      handler() {

      },
      immediate: true,
    },
    // internalPivotConfig: {
    //   handler(value) {
    //     this.$emit('change', value)
    //   },
    //   deep: true,
    // },
  },
  methods: {

    reloadDataCard() {
      this.$emit('reload-data-card')
    },
    toggleTableEdit() {
      this.tableEditOpen = !this.tableEditOpen
    },
  },
}
</script>

<style lang="stylus" scoped>
$icons = "bar-chart" "stacked-chart" "grouped-chart" "line-chart" "pie-chart" "pyramid-chart" "heat-map" "tree-map" "radar-chart" "connected-dotplot"

.statistics-chart
  display: flex
  min-height: 60vh
  width: 100%

  .mobile &
    flex-direction: column

.chart-panel
  flex: 0 0 vw(120px)
  overflow-x: hidden
  overflow-y: auto
  height: 600px 

  .mobile &
    position: sticky
    top: "calc(%s + %s + %s + %s)" % ($header-height $subheader-height vw(60px) vw(49px))
    z-index: 4
    flex: 0 0 vw(80px)
    overflow: auto
    width: 100vw
    background-color: white

.menu-hidden
  .mobile &
    display: none

.menu-grow
  display: flex
  transform-origin: top center
  animation: growDown 0.2s ease-in-out forwards

@keyframes growDown
  0%
    transform: scaleY(0)

  100%
    transform: scaleY(1)

.chart-item
  display: flex
  flex-direction: column
  align-items: center
  padding-top: vw(25px)
  padding-bottom: vw(25px)
  cursor: pointer

  .mobile &
    display: flex
    flex-direction: column
    align-items: center
    padding-top: vw(5px)
    padding-bottom: vw(15px)
    border-right: 1px solid $bcn-grey
    border-bottom: 1px solid $bcn-grey

  &.disabled,
  &.enableable
    color: $grey-grey
    pointer-events: none

    .chart-icon
      background-color: $grey-grey

  &:hover,
  &.active
    .chart-icon
      background-color: $corporate_color

    .chart-text
      color: $corporate_color

    &.enableable
      background-color: inherit

      .chart-icon
        background-color: $grey-grey

      .chart-text
        color: inherit

  &:hover
    background-color: $corpotative-color-very-light

  &.active
    background-color: $lighter-blue
    box-shadow: 4px 0 0 0 $corporate_color inset
    cursor: default

.chart-icon
  for $icon in $icons
    &.{$icon}
      m-icon($icon, 32, #000)
      margin: auto

.chart-text
  m-font-size(12, 16)
  padding: 0 vw(10px)
  min-width: vw(100px)
  text-align: center

.enable-button
  m-font-size(12, 16)
  display: flex
  justify-content: center
  align-items: center
  margin-top: vw(8px)
  color: $corporate_color
  text-align: center
  cursor: pointer
  pointer-events: all

  &:hover
    text-decoration: underline

  .enable-icon
    m-icon("plus", 14, $corporate_color)
    margin-top: -0.05em
    margin-right: vw(4px)
    margin-left: vw(-14px)

>>> .pivot-component
  .top
    padding: 0

  .left
    padding: vw(10px) vw(25px) 0 vw(45px)

  .right
    box-shadow: 0 4px 80px rgba(#000, 0.05)
</style>
